import { render } from "./LuckyDraw.vue?vue&type=template&id=20185a10&scoped=true"
import script from "./LuckyDraw.vue?vue&type=script&lang=js"
export * from "./LuckyDraw.vue?vue&type=script&lang=js"

import "./LuckyDraw.vue?vue&type=style&index=0&id=20185a10&scoped=true&lang=scss"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20185a10"]])

export default __exports__